export default "__VITE_ASSET__M3sHhfZF__"